export const ADMIN_LOADING = "admin/loading";
export const ADMIN_ERROR = "admin/error";
export const ADMIN_ROLES = "admin/roles";
export const ADMIN_FILTERS = "admin/filters";
export const ADMIN_LIST = "admin/list";
export const ADMIN_DELETE = "admin/delete";



// WEBPACK FOOTER //
// ./src/actions/admin/constants.js